/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderRefundResponsibility } from './OrderRefundResponsibility';
import {
    OrderRefundResponsibilityFromJSON,
    OrderRefundResponsibilityFromJSONTyped,
    OrderRefundResponsibilityToJSON,
    OrderRefundResponsibilityToJSONTyped,
} from './OrderRefundResponsibility';
import type { OrderRefundReason } from './OrderRefundReason';
import {
    OrderRefundReasonFromJSON,
    OrderRefundReasonFromJSONTyped,
    OrderRefundReasonToJSON,
    OrderRefundReasonToJSONTyped,
} from './OrderRefundReason';

/**
 * Represents a refund for a menu order.
 * @export
 * @interface OrderRefund
 */
export interface OrderRefund {
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OrderRefund
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefund
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    admin: string;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    menuOrder: string;
    /**
     * 
     * @type {OrderRefundReason}
     * @memberof OrderRefund
     */
    reason: OrderRefundReason;
    /**
     * 
     * @type {OrderRefundResponsibility}
     * @memberof OrderRefund
     */
    responsibility: OrderRefundResponsibility;
    /**
     * 
     * @type {number}
     * @memberof OrderRefund
     */
    responsiblePartyAmount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    refundId?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderRefund
     */
    fiat: number;
    /**
     * 
     * @type {number}
     * @memberof OrderRefund
     */
    fuel: number;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    fuelTransaction?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderRefund
     */
    lootShopCredit: number;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    lootShopCreditTransaction?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderRefund
     */
    coinbaseFuelX?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    coinbaseFuelXTransaction?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderRefund
     */
    rewardsClawback: number;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    rewardsClawbackTransaction?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderRefund
     */
    transferReverseAmount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderRefund
     */
    transferReverseId?: string;
}



/**
 * Check if a given object implements the OrderRefund interface.
 */
export function instanceOfOrderRefund(value: object): value is OrderRefund {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('admin' in value) || value['admin'] === undefined) return false;
    if (!('menuOrder' in value) || value['menuOrder'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('responsibility' in value) || value['responsibility'] === undefined) return false;
    if (!('responsiblePartyAmount' in value) || value['responsiblePartyAmount'] === undefined) return false;
    if (!('fiat' in value) || value['fiat'] === undefined) return false;
    if (!('fuel' in value) || value['fuel'] === undefined) return false;
    if (!('lootShopCredit' in value) || value['lootShopCredit'] === undefined) return false;
    if (!('rewardsClawback' in value) || value['rewardsClawback'] === undefined) return false;
    if (!('transferReverseAmount' in value) || value['transferReverseAmount'] === undefined) return false;
    return true;
}

export function OrderRefundFromJSON(json: any): OrderRefund {
    return OrderRefundFromJSONTyped(json, false);
}

export function OrderRefundFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderRefund {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'admin': json['admin'],
        'menuOrder': json['menuOrder'],
        'reason': OrderRefundReasonFromJSON(json['reason']),
        'responsibility': OrderRefundResponsibilityFromJSON(json['responsibility']),
        'responsiblePartyAmount': json['responsiblePartyAmount'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'refundId': json['refundId'] == null ? undefined : json['refundId'],
        'fiat': json['fiat'],
        'fuel': json['fuel'],
        'fuelTransaction': json['fuelTransaction'] == null ? undefined : json['fuelTransaction'],
        'lootShopCredit': json['lootShopCredit'],
        'lootShopCreditTransaction': json['lootShopCreditTransaction'] == null ? undefined : json['lootShopCreditTransaction'],
        'coinbaseFuelX': json['coinbaseFuelX'] == null ? undefined : json['coinbaseFuelX'],
        'coinbaseFuelXTransaction': json['coinbaseFuelXTransaction'] == null ? undefined : json['coinbaseFuelXTransaction'],
        'rewardsClawback': json['rewardsClawback'],
        'rewardsClawbackTransaction': json['rewardsClawbackTransaction'] == null ? undefined : json['rewardsClawbackTransaction'],
        'transferReverseAmount': json['transferReverseAmount'],
        'transferReverseId': json['transferReverseId'] == null ? undefined : json['transferReverseId'],
    };
}

export function OrderRefundToJSON(json: any): OrderRefund {
    return OrderRefundToJSONTyped(json, false);
}

export function OrderRefundToJSONTyped(value?: OrderRefund | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'admin': value['admin'],
        'menuOrder': value['menuOrder'],
        'reason': OrderRefundReasonToJSON(value['reason']),
        'responsibility': OrderRefundResponsibilityToJSON(value['responsibility']),
        'responsiblePartyAmount': value['responsiblePartyAmount'],
        'notes': value['notes'],
        'refundId': value['refundId'],
        'fiat': value['fiat'],
        'fuel': value['fuel'],
        'fuelTransaction': value['fuelTransaction'],
        'lootShopCredit': value['lootShopCredit'],
        'lootShopCreditTransaction': value['lootShopCreditTransaction'],
        'coinbaseFuelX': value['coinbaseFuelX'],
        'coinbaseFuelXTransaction': value['coinbaseFuelXTransaction'],
        'rewardsClawback': value['rewardsClawback'],
        'rewardsClawbackTransaction': value['rewardsClawbackTransaction'],
        'transferReverseAmount': value['transferReverseAmount'],
        'transferReverseId': value['transferReverseId'],
    };
}

